import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cut_ic_back",
  "use": "icon-cut_ic_back-usage",
  "viewBox": "0 0 17 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 31\" id=\"icon-cut_ic_back\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-13-9h48v48h-48z\" /><path stroke=\"#707076\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M15.51 2 2 15.51 15.51 29\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol